<div class="clearfix">
    <div class="float-left">
        <h1>
            {{ id === 0 ? 'Create' : 'Edit' }} User
            <!-- Display the user name if we have a first name value -->
            @if (formGroup.value.firstName) {
                <span>
                    - {{ formGroup.value.firstName }}
                    {{ formGroup.value.lastName }}
                </span>
            }
        </h1>
    </div>
</div>
<hr />

<ul
    ngbNav
    #nav="ngbNav"
    class="nav-tabs"
>
    <!-- Details -->
    <li ngbNavItem="Details">
        <a ngbNavLink>Details</a>
        <ng-template ngbNavContent>
            <form
                pcgSubmitUrl="api/Administration/Users/SaveUser"
                (messageReceive)="saveUser($event)"
                [localDbTbl]="'EditUserTbl'"
                [formGroup]="formGroup"
            >
                <!-- Activate/Deactivate button -->
                @if (formGroup.controls.userId.value != 0) {
                    <div class="activation-ctnr">
                        <pcg-control-group class="activate-btn">
                            <div class="row">
                                <div class="col-sm-1">
                                    <a
                                        [class.btn-danger]="
                                            formGroup.controls.isActive.value
                                        "
                                        [class.btn-save]="
                                            !formGroup.controls.isActive.value
                                        "
                                        class="btn btn-sm"
                                        (click)="
                                            formGroup.controls.isActive.value =
                                                !formGroup.controls.isActive
                                                    .value;
                                            activateDeactivate(
                                                formGroup.controls.userId.value,
                                                formGroup.controls.isActive
                                                    .value
                                            )
                                        "
                                    >
                                        {{
                                            formGroup.controls.isActive.value
                                                ? 'Deactivate'
                                                : 'Reactivate'
                                        }}
                                    </a>
                                    <button
                                        #submit
                                        [hidden]="true"
                                    ></button>
                                </div>
                            </div>
                            <p
                                [class.text-danger]="
                                    !formGroup.controls.isActive.value
                                "
                                [class.d-none]="
                                    formGroup.controls.isActive.value
                                "
                                class="ml-2"
                            >
                                This user is deactivated.
                            </p>
                        </pcg-control-group>
                    </div>
                }

                <!-- Details Section -->
                <pcg-collapsible-divider header="Details">
                    <input
                        type="hidden"
                        formControlName="userId"
                    />

                    <div class="row">
                        <pcg-control-group
                            class="col-md-4"
                            label="First Name"
                        >
                            <input
                                pcgControlRef
                                class="form-control"
                                type="text"
                                formControlName="firstName"
                            />
                        </pcg-control-group>

                        <pcg-control-group
                            class="col-md-4"
                            label="Last Name"
                        >
                            <input
                                pcgControlRef
                                class="form-control"
                                type="text"
                                formControlName="lastName"
                            />
                        </pcg-control-group>

                        <pcg-control-group
                            class="col-md-4"
                            label="Email"
                        >
                            <input
                                pcgControlRef
                                class="form-control email"
                                type="text"
                                formControlName="email"
                            />
                        </pcg-control-group>
                    </div>

                    <div class="row">
                        <pcg-control-group
                            class="col-md-4"
                            label="Phone"
                        >
                            <input
                                pcgPhoneExt
                                pcgControlRef
                                class="form-control"
                                type="text"
                                formControlName="phoneNumber"
                                maxlength="21"
                            />
                        </pcg-control-group>

                        <pcg-control-group
                            class="col-md-4"
                            label="Domicile"
                        >
                            <pcg-select
                                pcgControlRef
                                dataSource="api/Select/Domiciles"
                                formControlName="domicileId"
                                placeholder="Select a Domicile"
                            ></pcg-select>
                        </pcg-control-group>
                    </div>
                </pcg-collapsible-divider>

                <!-- Security Section -->
                <pcg-collapsible-divider header="Security">
                    <div class="row">
                        <pcg-control-group
                            class="col-md-4"
                            label="Username"
                            [validations]="userNameValidation"
                        >
                            <input
                                pcgControlRef
                                class="form-control"
                                maxlength="51"
                                type="text"
                                formControlName="userName"
                            />
                        </pcg-control-group>

                        <pcg-control-group
                            class="col-md-4"
                            label="Permissions"
                        >
                            <pcg-select
                                pcgControlRef
                                [multiple]="false"
                                dataSource="api/Select/Permissions"
                                formControlName="permissionId"
                            ></pcg-select>
                        </pcg-control-group>

                        <div
                            class="col-md-4"
                            id="divUnlockUser"
                        >
                            @if (isLockedOut && canUnlock) {
                                <span
                                    (click)="unlockUser()"
                                    ngbTooltip="This user is locked out. Click here to unlock the user and send them an email with login instructions."
                                    class="unlock"
                                    id="spanUnlockUser"
                                >
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                    >
                                        <g id="icomoon-ignore">
                                            <line
                                                stroke-width="1"
                                                x1=""
                                                y1=""
                                                x2=""
                                                y2=""
                                                opacity=""
                                            ></line>
                                        </g>
                                        <path
                                            d="M22.5 1.875h-3.75c-3.102 0-5.625 2.523-5.625 5.625v5.625h-11.719c-0.773 0-1.406 0.633-1.406 1.406v14.063c0 0.773 0.633 1.406 1.406 1.406h15.938c0.773 0 1.406-0.633 1.406-1.406v-14.063c0-0.773-0.633-1.406-1.406-1.406h-0.469v-5.625c0-1.034 0.841-1.875 1.875-1.875h3.75c1.034 0 1.875 0.841 1.875 1.875v5.625h3.75v-5.625c0-3.102-2.523-5.625-5.625-5.625zM11.25 26.25h-3.75l0.816-4.078c-0.492-0.338-0.816-0.905-0.816-1.547 0-1.036 0.839-1.875 1.875-1.875s1.875 0.839 1.875 1.875c0 0.642-0.323 1.209-0.816 1.547l0.816 4.078z"
                                        ></path>
                                    </svg>
                                </span>
                            }
                            @if (isCurrentUser) {
                                <input
                                    type="button"
                                    id="btnChangePassword"
                                    value="Change Password"
                                    (click)="openChangePasswordModal()"
                                    class="btn btn-save btn-lg"
                                />
                            }
                            @if (canResetPassword && canSeePasswordButtons) {
                                <input
                                    type="button"
                                    (click)="resetPassword(false)"
                                    class="btn btn-save btn-lg"
                                    ngbTooltip="Send user a reset password email with their username and the ability to choose a new password."
                                    value="Reset Password"
                                    id="btnResetPassword"
                                />
                            }
                            <br />
                            @if (canSendWelcomeEmail && canSeePasswordButtons) {
                                <input
                                    type="button"
                                    (click)="resetPassword(true)"
                                    class="btn btn-save btn-lg"
                                    ngbTooltip="Send user a welcome email with their username and the ability to choose a new password."
                                    value="Send Welcome Email"
                                    id="btnSendWelcomeMessage"
                                />
                            }
                        </div>
                    </div>
                </pcg-collapsible-divider>

                <!-- Address Section -->
                <pcg-collapsible-divider header="Address">
                    <div formGroupName="address">
                        <div class="row">
                            <pcg-control-group
                                class="col-md-4"
                                label="Address One"
                            >
                                <input
                                    pcgControlRef
                                    class="form-control"
                                    type="text"
                                    formControlName="addressOne"
                                />
                            </pcg-control-group>

                            <pcg-control-group
                                class="col-md-4"
                                label="Address Two"
                            >
                                <input
                                    pcgControlRef
                                    class="form-control"
                                    type="text"
                                    formControlName="addressTwo"
                                />
                            </pcg-control-group>
                        </div>

                        <div class="row">
                            <pcg-control-group
                                class="col"
                                label="State"
                            >
                                <pcg-select
                                    pcgControlRef
                                    dataSource="api/Select/StatesStringReference"
                                    formControlName="state"
                                    placeholder="Select a State"
                                ></pcg-select>
                            </pcg-control-group>

                            <pcg-control-group
                                class="col"
                                label="City"
                            >
                                <input
                                    pcgControlRef
                                    class="form-control"
                                    type="text"
                                    formControlName="city"
                                />
                            </pcg-control-group>

                            <pcg-control-group
                                class="col"
                                label="ZIP code"
                            >
                                <input
                                    pcgControlRef
                                    class="form-control"
                                    type="text"
                                    formControlName="zipCode"
                                    pcgZipCode
                                />
                            </pcg-control-group>
                        </div>
                    </div>
                </pcg-collapsible-divider>

                <pcg-fixed-buttons>
                    @if (!isCurrentUser || canEdit) {
                        <a
                            class="btn btn-cancel btn-lg"
                            routerLink="/administration/users"
                        >
                            Back
                        </a>
                    }
                    <button class="btn btn-save btn-lg">Save</button>
                </pcg-fixed-buttons>
            </form>
        </ng-template>
    </li>

    <!-- Employment Info -->
    @if (id !== 0) {
        <li ngbNavItem="Employment Info">
            <a ngbNavLink>Employment Info</a>
            <ng-template ngbNavContent>
                <pcg-user-employment [userId]="id"></pcg-user-employment>
            </ng-template>
        </li>
    }

    <!-- Login History -->
    @if (id !== 0 && canViewLoginHistory) {
        <li ngbNavItem="Login History">
            <a ngbNavLink>Login History</a>
            <ng-template ngbNavContent>
                <!-- This component is in the user-login-history directory under the edit-user component's directory -->
                <pcg-user-login-history [id]="id"></pcg-user-login-history>
            </ng-template>
        </li>
    }

    <!-- Audit History -->
    @if (id !== 0 && canViewReports) {
        <li ngbNavItem="Audit History">
            <a ngbNavLink>Audit History</a>
            <ng-template ngbNavContent>
                <!-- This component is in the user-audit-history directory under the edit-user component's directory -->
                <pcg-user-audit-history [id]="id"></pcg-user-audit-history>
            </ng-template>
        </li>
    }
</ul>
<div [ngbNavOutlet]="nav"></div>
